<template>
  <ul>
    <li v-for="(item, index) in options" :key="index">
      <label>
        <input type="radio" v-model="model" :value="item" />
        <span>{{ item }}</span>
      </label>
    </li>
  </ul>
  <!--p class='debug'>model = {{ model }}</p>-->
</template>

<script setup lang="ts">
const props = defineProps({
  options: { type: Array<any>, required: true } //this should just be plain string arrays?
})

const model = defineModel<any>('selected')
</script>

<style lang="css" scoped>
label {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 0.5rem;
  padding-left: 0;
  padding-right: 1rem;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  max-height: 16rem;
  margin-bottom: 1rem;
}
</style>
